import {
    $get,
    $post
} from '@/utils/http'

export default {
    // 廉政档案
    getleader(params) {
        return $post('/portal/websit/incorruptibleRecordManager/listRecordForLeader', params)
    },
    getgroup(params) {
        return $post('/portal/websit/incorruptibleRecordManager/listRecordForGroup', params)
    },
    getsecond(params) {
        return $post('/portal/websit/incorruptibleRecordManager/listRecordForTwoLevel', params)
    },
    
}
